import { useState, useCallback, useEffect } from 'react';
import { smbsApi } from '../../services/api';
import { ColumnConfigItem } from '../../types/lead';

export function useLeadsTableConfig(smbId?: string) {
  const [columnsConfig, setColumnsConfig] = useState<ColumnConfigItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTableConfig = useCallback(async () => {
    if (!smbId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await smbsApi.getLeadsTableConfig(smbId);
      setColumnsConfig(res.columns || []);
    } catch (err: any) {
      console.error('Failed to fetch leads table config:', err);
      setError(err.message || 'Failed to load table configuration');
    } finally {
      setLoading(false);
    }
  }, [smbId]);

  useEffect(() => {
    fetchTableConfig();
  }, [fetchTableConfig]);

  const saveTableConfig = useCallback(
    async (updatedColumns: ColumnConfigItem[]) => {
      if (!smbId) return;
      setLoading(true);
      setError(null);
      try {
        const res = await smbsApi.updateLeadsTableConfig(smbId, updatedColumns);
        setColumnsConfig(res.columns || []);
        return res.columns;
      } catch (err: any) {
        console.error('Failed to save leads table config:', err);
        setError(err.message || 'Failed to update table configuration');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [smbId]
  );

  return {
    columnsConfig,
    loading,
    error,
    fetchTableConfig,
    saveTableConfig,
    setColumnsConfig,
  };
}
